<!--<div class="row justify-content-center" *ngIf="loading === false">-->
<!--  <div class="col-md-11">-->
<!--    <div class="tracker-container p-3 my-4">-->

<!--      <ng-stepper #cdkStepper [linear]="true" class="mt-4" [selectedIndex]="index" >-->

<!--        <cdk-step [editable]="false" [stepControl]="" [completed]="index >0" >-->
<!--          <ng-template cdkStepLabel>-->
<!--            <div class="step-bullet">1</div>-->
<!--            <div class="step-title">Appeal submitted</div>-->
<!--          </ng-template>-->
<!--          &lt;!&ndash; <app-apply-details kinType="Father"></app-apply-details> &ndash;&gt;-->
<!--        </cdk-step>-->
<!--        <cdk-step [editable]="false" [stepControl]="" [completed]="index >1">-->
<!--          <ng-template cdkStepLabel>-->
<!--            <div class="step-bullet">2</div>-->
<!--            <div class="step-title">Appeal in progress</div>-->
<!--          </ng-template>-->
<!--          &lt;!&ndash; <app-apply-details kinType="Gaurdian"></app-apply-details> &ndash;&gt;-->
<!--        </cdk-step>-->

<!--        <cdk-step [editable]="false" [stepControl]="" [completed]="index >2">-->
<!--          <ng-template cdkStepLabel>-->
<!--            <div class="step-bullet">3</div>-->
<!--            <div class="step-title">Appeal Pending Outstanding Documents</div>-->
<!--          </ng-template>-->
<!--          &lt;!&ndash; <app-apply-docs></app-apply-docs> &ndash;&gt;-->
<!--        </cdk-step>-->

<!--        <cdk-step [editable]="false" [stepControl]="" [completed]="index >3">-->
<!--          <ng-template cdkStepLabel>-->
<!--            <div class="step-bullet">4</div>-->
<!--            <div class="step-title">Appeal Rejected</div>-->
<!--          </ng-template>-->
<!--          &lt;!&ndash; <app-apply-details kinType="Mother"></app-apply-details> &ndash;&gt;-->
<!--        </cdk-step>-->

<!--        <cdk-step [editable]="false" [stepControl]="" [completed]="index >4">-->
<!--          <ng-template cdkStepLabel>-->
<!--            <div class="step-bullet">5</div>-->
<!--            <div class="step-title">Appeal Finalized</div>-->
<!--          </ng-template>-->
<!--          &lt;!&ndash; <app-apply-details kinType="Spouse"></app-apply-details> &ndash;&gt;-->
<!--        </cdk-step>-->
<!--        <cdk-step [editable]="false" [stepControl]="" [completed]="index >5">-->
<!--          <ng-template cdkStepLabel>-->
<!--            <div class="step-bullet">6</div>-->
<!--            <div class="step-title">Appeal Withdrawn</div>-->
<!--          </ng-template>-->
<!--          &lt;!&ndash; <app-apply-details kinType="Spouse"></app-apply-details> &ndash;&gt;-->
<!--        </cdk-step>-->
<!--      </ng-stepper>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!-- Container with grid layout for multiple appeals -->
<div class="appeals-container">
  <div *ngIf="appeals.length === 0" class="text-center p-5">
    <p class="text-muted">No appeals found</p>
  </div>
  
  <div *ngIf="appeals.length > 0" 
       [class.grid-view]="appeals.length > 1" 
       [class.single-view]="appeals.length === 1">
    
    <div *ngFor="let appeal of appeals; let i = index" class="appeal-card ">
      
      <!-- Card Header with Status Badge -->
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h5 class="mb-0">
              Appeal #{{i + 1}}
            </h5>
            <small class="text-light opacity-75"> Ref: {{appeal?.application?.reference}}</small>
          </div>
          <span class="status-badge" [ngClass]="{
            'status-pending': appeal.status === 'Pending',
            'status-approved': appeal.status === 'Approved',
            'status-rejected': appeal.status === 'Rejected',
            'status-reprocess': appeal.status === 'ReProcess',
            'status-closed': appeal.status === 'Closed'
          }">
            Appeal Status: {{apealStatus(appeal)}}
          </span>
        </div>
      </div>
      
      <!-- Card Body - Fully Expanded -->
      <div class="card-body">
        
        <!-- Status Messages -->
        <div *ngIf="appeal.status === 'ReProcess'" class="info-message info-warning mb-3">
          <i class="fa fa-info-circle me-2"></i>
          <strong>Reprocess Reason:</strong> {{appeal?.appealReProcessReason?.name}}
        </div>
        
        <div *ngIf="appeal.status === 'Closed' && appeal?.closedReason !== null" class="info-message info-secondary mb-3">
          <i class="fa fa-check-circle me-2"></i>
          <strong>Closed Reason:</strong> {{appeal?.closedReason}}
        </div>

        <!-- Applicant Information Section -->
        <div class="section mb-4">
          <h6 class="section-title">
            <i class="fa fa-user me-2"></i>Applicant Information
          </h6>
          <div class="info-grid">
            <div class="info-label">Name:</div>
            <div class="info-value">{{appeal.application?.user?.firstName}} {{appeal.application?.user?.lastName}}</div>

            <div class="info-label">Application Status:</div>
            <div class="info-value"><span class="">{{getStatus(application)}}</span></div>
          </div>
        </div>
        <!-- Additional Information Section -->
        <div class="section mb-4" *ngIf="appeal.deceased">
          <h6 class="section-title">
            <i class="fa fa-user-times me-2"></i>Additional Information: <strong class="info-value text-danger">Deceased</strong>
          </h6>
          <div class="info-grid">
            <div class="info-label">Name:</div>
            <div class="info-value">{{appeal.deceased?.firstName}} {{appeal.deceased?.lastName}}</div>
            
            <div class="info-label">ID Number:</div>
            <div class="info-value">{{appeal.deceased?.idNumber}}</div>

            <div class="info-label">Relationship:</div>
            <div class="info-value">{{appeal.deceased?.relationship}}</div>
          </div>
        </div>

        <div class="section mb-4" *ngIf="appeal.child">
          <h6 class="section-title">
            <i class="fa fa-child me-2"></i>Additional Information: <strong class="info-value text-danger">Child</strong>
          </h6>
          <div class="info-grid">
            <div class="info-label">Name:</div>
            <div class="info-value">{{appeal.child?.firstName}} {{appeal.child?.lastName}}</div>
            
            <div class="info-label">ID Number:</div>
            <div class="info-value">{{appeal.child?.idNumber}}</div>
          </div>
        </div>

        <div class="section mb-4" *ngIf="appeal.illness">
          <h6 class="section-title">
            <i class="fa fa-stethoscope me-2"></i>Additional Information: <strong class="info-value text-danger">Illness</strong>
          </h6>
          <div class="info-grid">
            <div class="info-label">Doctor's Practice Number:</div>
            <div class="info-value">{{appeal.illness?.practiceNumber}}</div>

            <div class="info-label">Date of Illness:</div>
            <div class="info-value">{{appeal.illness?.dateOfIllness | date}}</div>

            <div class="info-label">Facility Type:</div>
            <div class="info-value">{{appeal.illness?.facilityType}}</div>

            <div class="info-label">Facility Name:</div>
            <div class="info-value">{{appeal.illness?.facilityName}}</div>
          </div>
        </div>

        <!-- Appeal Reasons Section -->
        <div class="section mb-4" *ngIf="appeal?.appealReason?.rejectReason || appeal?.appealReProcessReason || appeal?.rejectAppealReProcessReason">
          <h6 class="section-title">
            <i class="fa fa-gavel me-2"></i>Appeal Details
          </h6>
          <div class="info-grid">
            <div *ngIf="appeal?.appealReason?.rejectReason" class="reason-item">
              <div class="info-label">Appeal Reject Reason:</div>
              <div class="info-value text-danger">{{appeal?.appealReason?.rejectReason.description}}</div>
              <div class="info-label">Appeal Reason:</div>
              <div class="info-value text-danger">{{appeal?.appealReason?.description}}</div>
            </div>
            
            <div *ngIf="appeal?.appealReProcessReason" class="reason-item">
              <div class="info-label">Re-Process Reason:</div>
              <div class="info-value">{{appeal?.appealReProcessReason?.name}}</div>
            </div>
            
            <div *ngIf="appeal?.rejectAppealReProcessReason" class="reason-item">
              <div class="info-label">Re-Process Reject Reason:</div>
              <div class="info-value text-danger">{{appeal?.rejectAppealReProcessReason?.name}}</div>
            </div>
          </div>
        </div>

        <!-- Documents Section -->
        <div class="section mb-4">
          <h6 class="section-title">
            <i class="fa fa-file-text-o me-2"></i>Documents
          </h6>
          
          <!-- Supporting Documents -->
          <div *ngIf="appeal.submittedDocuments?.length > 0" class="doc-group mb-3">
            <div class="doc-group-title">
              <i class="fa fa-paperclip me-1"></i>
              Supporting Documents 
            </div>
            <div class="doc-list">
              <a *ngFor="let supportingDocument of appeal.submittedDocuments" 
                 target="_blank" 
                 [href]="configService.getApi()+'file/'+supportingDocument.id"
                 class="doc-link">
                <i class="fa fa-file-pdf-o"></i>
                {{supportingDocument.name}}
              </a>
            </div>
          </div>

          <!-- Disability Annexure -->
          <div *ngIf="appeal.application?.disabilityAnnexure && appeal.application?.disabilityAnnexure.id" class="doc-group mb-3">
            <div class="doc-group-title">
              <i class="fa fa-wheelchair me-1"></i>
              Disability Annexure
            </div>
            <div class="doc-list">
              <a target="_blank" 
                 [href]="configService.getApi()+'file/'+appeal.application?.disabilityAnnexure.id"
                 class="doc-link">
                <i class="fa fa-file-pdf-o"></i>
                {{appeal.application?.disabilityAnnexure.name}}
              </a>
            </div>
          </div>

          <!-- Family Members Documents - Using ng-template for consistency -->
          <ng-container *ngTemplateOutlet="familyMemberDocs; context: {member: appeal.application?.spouse, title: 'Spouse'}"></ng-container>
          <ng-container *ngTemplateOutlet="familyMemberDocs; context: {member: appeal.application?.father, title: 'Father'}"></ng-container>
          <ng-container *ngTemplateOutlet="familyMemberDocs; context: {member: appeal.application?.mother, title: 'Mother'}"></ng-container>
          <ng-container *ngTemplateOutlet="familyMemberDocs; context: {member: appeal.application?.guardian, title: 'Guardian'}"></ng-container>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <button *ngIf="appeal.canWithdraw" 
                  class="btn-action btn-danger" 
                  (click)="withdraw(appeal)">
            <i class="fa fa-times-circle me-2"></i>Cancel Appeal
          </button>
          
          <button *ngIf="appeal.canReOpenWithdrawn" 
                  class="btn-action btn-success" 
                  (click)="reOpenWithdrawn(appeal)">
            <i class="fa fa-repeat me-2"></i>Re-Open Appeal
          </button>
          
          <button *ngIf="appeal.canRequestReprocess" 
                  class="btn-action btn-primary" 
                  (click)="reProcessAppeal(appeal)">
            <i class="fa fa-refresh me-2"></i>Request Reprocess
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Template for family member documents -->
<ng-template #familyMemberDocs let-member="member" let-title="title">
  <div *ngIf="member && member.idNumber" class="family-member-card mb-3">
    <div class="family-member-header">
      <i class="fa fa-users me-1"></i>
      <strong>{{title}}</strong>
    </div>
    <div class="family-member-info">
      <div>{{member.firstName}} {{member.lastName}}</div>
      <div class="text-muted small">{{member.idNumber}}</div>
    </div>
    <div *ngIf="member.supportingDocs && member.supportingDocs.length > 0" class="doc-list mt-2">
      <div *ngFor="let document of member.supportingDocs" class="doc-item">
        <span class="doc-caption">{{document.caption}}:</span>
        <a target="_blank" [href]="configService.getApi()+'file/'+document.id" class="doc-link small">
          <i class="fa fa-file-pdf-o"></i> {{document.name}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
